import { render, staticRenderFns } from "./SidebarBet.vue?vue&type=template&id=1da5e8c6&scoped=true&"
import script from "./SidebarBet.vue?vue&type=script&lang=js&"
export * from "./SidebarBet.vue?vue&type=script&lang=js&"
import style0 from "./SidebarBet.vue?vue&type=style&index=0&id=1da5e8c6&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1da5e8c6",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1da5e8c6')) {
      api.createRecord('1da5e8c6', component.options)
    } else {
      api.reload('1da5e8c6', component.options)
    }
    module.hot.accept("./SidebarBet.vue?vue&type=template&id=1da5e8c6&scoped=true&", function () {
      api.rerender('1da5e8c6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/wheel/components/SidebarBet.vue"
export default component.exports